export class TypeLangue {

	public langAutre: string;

	public langEC: string[];

	constructor() { 
		 		this.langAutre = '';
		this.langEC = [];
 
	}
}
